<mat-menu #appMenu="matMenu">
  <button
    mat-menu-item
    *ngFor="let option of valList"
    (click)="addValidator(option)"
  >
    {{ option.name }}
  </button>
</mat-menu>
<div class="ps_formBuilder_formContainer">
  <div fxLayout="row wrap">
    <span class="ps_formBuilder_text" style="margin-top: 5px" fxFlex="100">Validador</span>
    <div fxFlex="100">
      <mat-slide-toggle
        fxFlex="100"
        [color]="'primary'"
        [formControl]="activeValidators"
      >
        {{ activeValidators.value == true ? "Ativado" : "Desativado" }}
      </mat-slide-toggle>
    </div>
    <span class="ps_formBuilder_text" style="margin-top: 5px" fxFlex="100">
      Validadores verificam se os dados inseridos pelo usuário são
      válidos.</span
    >
    <div fxFlex="100" style="margin-top: 15px" fxLayoutAlign="start center">
      <mat-form-field fxFlex="75" appearance="fill">
        <mat-label>Mensagem de campo inválido</mat-label>
        <input [formControl]="message" matInput placeholder="" />
      </mat-form-field>
    </div>
    <p
      class="ps_formBuilder_noValidators"
      *ngIf="ValidatorList.length === 0 && activeValidators.value"
    >
      Ainda não há validadores, clique em "Adicionar validador" para adicionar
      um.
    </p>
    <div fxLayout="row wrap" fxFlex="100">
      <div fxLayout="row wrap" fxFlex="100" [formGroup]="validators">
        <div
          formArrayName="formArray"
          *ngFor="let validator of ValidatorList; let i = index"
          fxFlex="100"
          fxLayout="row wrap"
          fxLayoutAlign="start"
        >
          <div
            *ngIf="validator.editing"
            fxLayout="row wrap"
            class="ps_formBuilder_validatorContainer mat-elevation-z1"
            [formGroupName]="i"
          >
            <span
              *ngIf="validator.editing"
              fxFlex="100"
              class="ps_formBuilder_validatorTitle"
              >{{ validator.name }}</span
            >
            <div fxFlex="100">
              <mat-form-field
                appearance="fill"
                fxFlex="90"
                *ngIf="validator.type === 'string'"
              >
                <input
                  matInput
                  formControlName="value"
                  placeholder="Insira um valor"
                  formControlName="value"
                />
              </mat-form-field>
              <span *ngIf="validator.key === 'pattern'">
                <mat-icon class="ps_formBuilder_tooltipIcon" 
                matTooltip='A expressão regular deverá começar e terminar com "/". Exemplo: /[a-z0-9]/' matTooltipPosition="after" matTooltipClass="ps-tooltip-content" svgIcon="help"></mat-icon>
              </span>
            </div>
            <div fxFlex="100">
              <mat-form-field
                appearance="fill"
                fxFlex="40"
                *ngIf="validator.type === 'number'"
              >
                <input
                  matInput
                  type="number"
                  min="1"
                  formControlName="value"
                  placeholder="Insira um valor"
                  formControlName="value"
                />
              </mat-form-field>
            </div>
            <div fxFlex="100" style="margin: 10px 0">
              <mat-slide-toggle
                *ngIf="validator.type === 'boolean'"
                fxFlex="100"
                [color]="'primary'"
                formControlName="value"
              >
                {{
                  getForm(i).controls.value.value == true
                    ? "Ativado"
                    : "Desativado"
                }}
              </mat-slide-toggle>
            </div>
            <div fxFlex="100" *ngIf="validator.type !== 'code'">
              <mat-form-field appearance="fill" fxFlex="90">
                <mat-label>Mensagem personalizada</mat-label>
                <input matInput formControlName="message" />
              </mat-form-field>
            </div>
            <div
              fxFlex="100"
              fxLayout="row wrap"
              style="margin-bottom: 10px"
              *ngIf="validator.key === 'pattern'"
            >
              <span class="ps_formBuilder_text" style="margin-top: 5px" fxFlex="100"
                >Inverter <mat-icon class="ps_formBuilder_tooltipIcon" matTooltip="Inverte a aplicação da expressão regular procurando não conter o padrão estabelecido por ela" matTooltipPosition="after" matTooltipClass="ps-tooltip-content" svgIcon="help"></mat-icon></span> 
              <mat-slide-toggle
                fxFlex="100"
                [color]="'primary'"
                formControlName="reverse"
              >
                {{
                  getForm(i).controls.reverse.value == true
                    ? "Ativado"
                    : "Desativado"
                }}
              </mat-slide-toggle>
            </div>
            <div
              fxFlex="100"
              fxLayout="row wrap"
              *ngIf="validator.type === 'code'"
            >
              <span class="ps_formBuilder_text" style="margin-top: 5px" fxFlex="100">
                As seguintes variáveis estão disponíveis no script
              </span>
              <table class="ps_formBuilder_table table-bordered table-condensed table-striped">
                <tbody>
                  <tr>
                    <th>input</th>
                    <td>O valor inserido no campo</td>
                  </tr>
                  <tr>
                    <th>component</th>
                    <td>O objeto JSON do componente</td>
                  </tr>
                  <tr>
                    <th>value</th>
                    <td>O valor atual do componente.</td>
                  </tr>
                  <tr>
                    <th>moment</th>
                    <td>A biblioteca moment.js para manipulação de datas.</td>
                  </tr>
                </tbody>
              </table>
              <td-code-editor
                fxFlex="97"
                formControlName="value"
                style="height: 300px"
                class="ps_formBuilder_editor"
                [disabled]=""
                theme="vs-dark"
                flex
                [editorOptions]="{
                  minimap: { enabled: false },
                  autoIndent: 'full'
                }"
                [language]="'javascript'"
              ></td-code-editor>
              <span class="ps_formBuilder_text" style="margin-top: 5px" fxFlex="97">
                Insira o código personalizado
              </span>
              <span class="ps_formBuilder_text" style="margin-top: 5px" fxFlex="97">
                Você deve retornar a mensagem de erro se a validação falhar
              </span>
              <span class="ps_formBuilder_validatorTitle" style="margin-top: 5px" fxFlex="97">
                Exemplo:
              </span>
              <span class="ps_formBuilder_text" style="margin-top: 5px" fxFlex="97">
                if&#40;input === "Jonatas"&#41; &#123;<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;return "O campo nome não pode ser
                Jonatas"<br />
                &#125;
                <!-- fazer um exemplo melhor -->
              </span>
            </div>
            <button
              [disabled]="!activeValidators.value || !validator.editable"
              (click)="removeRule(i)"
              mat-icon-button

            >
              <mat-icon>delete</mat-icon>
            </button>
            <button
              [disabled]="
                !activeValidators.value
              "
              (click)="stopEditing(i)"
              mat-icon-button

            >
              <!-- engrenagem aberta -->
              <mat-icon
                svgIcon="upArrow"
                [ngClass]="{
                  buttonDisabled: !activeValidators.value
                }"
                style="height: 27px; width: 24px;"
              ></mat-icon>
            </button>
          </div>
          <div
            *ngIf="!validator.editing"
            class="ps_formBuilder_validatorContainerClosed mat-elevation-z1"
          >
            <span *ngIf="!validator.editing">{{ validator.name }}</span>
            <button
              [disabled]="!activeValidators.value || !validator.editable"
              (click)="removeRule(i)"
              mat-icon-button
              aria-label="Remover"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <button
              [disabled]="!activeValidators.value"
              (click)="editRule(i)"
              mat-icon-button
              aria-label="Editar"
            >
              <mat-icon>settings</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="ps_formBuilder_addVal" fxFlex="100">
        <button
        *ngIf="activeValidators.value"
          mat-stroked-button
          color="primary"
          [matMenuTriggerFor]="appMenu"
        >
          <mat-icon>add</mat-icon> Validador
        </button>
      </div>
    </div>
  </div>
</div>
